import { ApiClient } from "../utils/api-client";
import { authService } from "./auth";
import { useSearchParams } from "react-router-dom";

// https://dev-api-gfc.mytatva.in/health
const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL, //"https://dev-api-gfc.mytatva.in/api/v8", //  process.env.REACT_APP_API_SYMPTOMBOT_BASE_URL || 'https://tatva-symptom-bot-uat.mytatva.in',
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "api-key": process.env.REACT_APP_API_KEY || "lChjFRJce3bxmoS3TSQk5w==",
  },
};

const apiClient = new ApiClient(API_CONFIG);

export type SymptomWelcomeResponse = {
  session_id: string;
  message: string;
  options?: { label: string; value: string }[];
};

export type SymptomMessageResponse = {
  message: string;
  options?: { label: string; value: string }[];
};

export type SymptomData = {
  name: string;
  imageURL: string;
  questionaireContainerName: string;
  questionaireData: string;
};

export type SymptomListResponse = {
  data: SymptomData[];
};

export const symptomService = {
  async startSession(userId: string): Promise<SymptomWelcomeResponse> {
    const res = await apiClient.post<SymptomWelcomeResponse>(
      "/symptom/session",
      { user_id: userId },
      { requireAuth: false }
    );
    return res.data;
  },

  async getSymptoms(): Promise<SymptomListResponse> {
    //const currentUser = authService.getCurrentUser()
    //console.log("currentUser for getSymptoms", currentUser)
    // http://localhost:8080/api/v8/patient_visit_symptoms/fetch_psp_symptoms_questionnaire?support_program_type=onco
    const res = await apiClient.get<SymptomListResponse>(
      "/api/v8/patient_visit_symptoms/fetch_psp_symptoms_questionnaire?support_program_type=tukavo",
      { encrypted: true }
    );
    //await handleResponse(res.data)
    return res.data;
  },

  async getQuestionnaires(
    fileName: string,
    containerName: string
  ): Promise<any> {
    // http://localhost:8080/api/v8/azure_services/fetch_json_from_blob_storage%27
    //const currentUser = authService.getCurrentUser()
    //console.log("currentUser for getSymptoms", currentUser)
    // http://localhost:8080/api/v8/patient_visit_symptoms/fetch_psp_symptoms_questionnaire?support_program_type=onco
    const res = await apiClient.post<any>(
      "/api/v8/azure_services/fetch_json_from_blob_storage",
      {
        fileName: fileName || "onco-vomitting.json",
        containerName: containerName || "onco-symptoms-questionnaires",
      },
      {
        encrypted: true,
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    //await handleResponse(res.data)
    //console.log(" res for get questions for symptoms", res);
    return res.data;
  },

  async logPatientSymptom(payload: any): Promise<any> {
    const res = await apiClient.post<any>(
      "/api/v8/patient_visit_symptoms/addPatientSymptoms",
      payload,
      {
        encrypted: true,
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    //await handleResponse(res.data)
    return res.data;
  },

  async sendMessage(
    sessionId: string,
    payload: { message?: string; value?: string }
  ): Promise<SymptomMessageResponse> {
    const res = await apiClient.post<SymptomMessageResponse>(
      "/symptom/message",
      { session_id: sessionId, ...payload },
      { requireAuth: false }
    );
    return res.data;
  },
};
